var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExhibitionSpace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38828 10.9275C5.51532 10.7836 5.69792 10.7012 5.88994 10.7012H16.5965C16.7885 10.7012 16.9711 10.7836 17.0982 10.9275C17.2254 11.0713 17.2843 11.2629 17.2606 11.4533L15.253 27.5137C15.2111 27.8485 14.9266 28.0999 14.5889 28.0999H7.8975C7.55985 28.0999 7.27527 27.8485 7.2334 27.5137L5.22585 11.4533C5.2021 11.2629 5.26124 11.0713 5.38828 10.9275ZM6.64793 12.0395L8.48811 26.7617H13.9985L15.8387 12.0395H6.64793Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.685615 6.93598C0.812653 6.77869 1.004 6.6875 1.2061 6.6875H21.2816C21.4837 6.6875 21.675 6.77869 21.8019 6.93598C21.9291 7.09304 21.9782 7.29917 21.9358 7.49679L19.9283 16.8657C19.8622 17.1743 19.5897 17.3945 19.2741 17.3945H16.5972V16.0562H18.7332L20.4537 8.02603H2.03414L3.75466 16.0562H5.89058V17.3945H3.21377C2.8983 17.3945 2.62562 17.1743 2.55954 16.8657L0.551993 7.49679C0.509647 7.29917 0.558715 7.09304 0.685753 6.93598H0.685615Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55895 3.69904L10.2763 1.22098L9.5338 0.107422L5.5187 2.784C5.33251 2.90813 5.2207 3.11717 5.2207 3.34078V7.35588H6.55899L6.55895 3.69904Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2168 26.7637H17.9358V28.102H4.2168V26.7637Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibitionSpace);
export default __webpack_public_path__ + "static/media/ExhibitionSpace.c6af4ac73cf02c020af9dfa5ee0acfe1.svg";
export { ForwardRef as ReactComponent };